export enum NoticeMessage {
    'not.in.kyc' = 'กรุณาตรวจสอบข้อมูลของท่านก่อนยืนยันตัวตนอีกครั้ง หากท่านยังไม่เคยสมัครใช้บริการมาก่อนสามารถยื่นขอสินเชื่อได้ผ่านแอป Money Thunder',
    'not.confirmed.cognito' = 'กรุณาตรวจสอบข้อมูลของท่านก่อนยืนยันตัวตนอีกครั้ง หากท่านยังไม่เคยสมัครใช้บริการมาก่อนสามารถยื่นขอสินเชื่อได้ผ่านแอป Money Thunder',
    'already.cid' = 'คุณได้ผ่านการยืนยันตัวตนเรียบร้อยแล้ว',
    'already.kyc' = 'ท่านต้องการยืนยันตัวตนด้วยมือถือนี้แทนอุปกรณ์อื่นที่เคยลงทะเบียนไว้หรือไม่',
    'too.many.request' = 'ขอ OTP เกินที่กำหนด กรุณาดำเนินการอีกครั้งในอีก 15 นาที ',
    'otp.not.valid' = 'OTP ไม่ถูกต้อง กรุณาตรวจสอบและดำเนินการอีกครั้ง',
    'internal.redis.missing.key' = 'ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง',
    'internal.error' = 'ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง',

    ABORTED_AUTHEN = 'การยืนยันตัวตนของคุณยังไม่เสร็จสมบูรณ์ กรุณากดปุ่มยืนยันตัวตนอีกครั้ง',
    ABORTED_AUTHEN_LINE_SHARING = 'ยืนยันตัวตนไม่สำเร็จ กรุณายืนยันตัวตนใหม่เพื่อร่วมกิจกรรมลุ้นรับค่างวดเดือน ต.ค. 63',
}
